import React from "react";
import PropTypes from "prop-types";

import { SnackbarProvider, closeSnackbar } from "notistack";
import IconButtonCross from "components/buttons/IconButtonCross";

const SnackbarWithCloseProvider = (props) => {
  const { children } = props;

  return (
    <SnackbarProvider
      maxSnack={3}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      action={(key) => (
        <IconButtonCross
          id="close-snackbar-button"
          size="18px"
          onClick={() => closeSnackbar(key)}
          sx={{
            color: ({ palette }) => palette.primary.onPrimary,
          }}
        />
      )}
    >
      {children}
    </SnackbarProvider>
  );
};

SnackbarWithCloseProvider.propTypes = {
  children: PropTypes.element.isRequired,
};

export default SnackbarWithCloseProvider;
